import React from 'react';
import { LocationText } from './DataCardLocation.styles';

/**
 * Get the top address to display in the location card
 */
export const getTopAddress = (
  street_1: string | null,
  street_2: string | null,
) => {
  if (street_1 && street_1 !== ' ') {
    if (street_2) {
      return <LocationText>{`${street_1} ${street_2}\u00A0`}</LocationText>;
    } else {
      return <LocationText>{`${street_1}\u00A0`}</LocationText>;
    }
  } else if (street_2 && !street_1) {
    return (
      <>
        <LocationText color="secondaryText" fontWeight="regular">
          (Bldg# N/A)
        </LocationText>
        {`${street_2}\u00A0`}
      </>
    );
  } else {
    return (
      <LocationText color="secondaryText" fontWeight="regular">
        {`Street not available\u00A0`}
      </LocationText>
    );
  }
};
